/**
 * Beneficiary name for a bank withdrawal, in the language of the bank country:
 * Russian for RU, Armenian for AM, English otherwise. Built from the profile
 * translations (`profile.translations.{name,surname,fatherName}.{hy,ru,en}`).
 * Used by the client withdrawal page and the admin Create Withdrawal modal.
 */
export type BeneficiaryNameLang = 'hy' | 'ru' | 'en';

export function beneficiaryNameLang(
  countryCode: string | null | undefined
): BeneficiaryNameLang {
  const code = (countryCode || '').trim().toUpperCase();
  if (code === 'RU') return 'ru';
  if (code === 'AM') return 'hy';
  return 'en';
}

const clean = (value: unknown): string => String(value ?? '').trim();

/**
 * Russian: surname, name, patronymic. Other languages: name, surname.
 * English falls back to the untranslated profile name; Russian and Armenian
 * return '' when there is no translation, so the field is left to be typed.
 */
export function beneficiaryNameFor(
  user: any,
  countryCode: string | null | undefined
): string {
  const lang = beneficiaryNameLang(countryCode);
  const translations = user?.profile?.translations;
  const name = clean(translations?.name?.[lang]);
  const surname = clean(translations?.surname?.[lang]);

  if (lang === 'ru') {
    const fatherName = clean(translations?.fatherName?.[lang]);
    return [surname, name, fatherName].filter(Boolean).join(' ');
  }
  if (name || surname || lang !== 'en') {
    return [name, surname].filter(Boolean).join(' ');
  }
  return [
    clean(user?.profile?.name || user?.firstName),
    clean(user?.profile?.surname || user?.lastName),
  ]
    .filter(Boolean)
    .join(' ');
}
